<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title" aria-hidden="true"> {{'INCOME_AND_DEDUCTIONS' | globalTranslate}} </h1>
  </div>
  <div class="modal-body">
        <h2 class="page-header sr-only" role="heading" aria-level="1">{{ 'INCOME_AND_DEDUCTIONS' | globalTranslate }}</h2>
    <div>
      <div class="panel-section">
        <div>
          <p>{{'INCOME_MODAL_TEXT1' | globalTranslate}}</p>
          <p class="static-text" id="incomeModalQuestion">
            <span class="text-danger" aria-hidden="true">*</span>
            <span [innerHTML]="'INCOME_MODAL_TEXT2' | globalTranslate"></span>
          </p>
        </div>
        <div class="col" role="radiogroup" aria-labelledby="incomeModalQuestion" aria-required="true">
          <label class="radio-inline checkbox">
            <input class="chk-input chk-gap" id="incomeModalYesCheck" type="radio"
              name="incomeModalYesNoCheck" (change)="changeOption($event)" value="Yes" [checked]="incomeModalSelectYes">
            <span class="chk-lbl">{{'Yes' | globalTranslate }}</span>
          </label>

          <label class="radio-inline checkbox ms-5">
            <input class="chk-input chk-gap" id="incomeModalNoCheck" type="radio"
              name="incomeModalYesNoCheck" (change)="changeOption($event)" value="No" [checked]="incomeModalSelectNo">
            <span class="chk-lbl">{{'No' | globalTranslate }}</span>
          </label>
        </div>
      </div>
    </div>
    <nh-alert type="warning" [isOpen]="mailingAddressAlert">
      <div class="row">
        <div class="col-auto icon">
          <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg" alt="" aria-hidden="true"/>
        </div>
        <div class="col message">
          <span>{{'ENTER_MANDATORY' | globalTranslate }}</span>
        </div>
      </div>
    </nh-alert>
  </div>
  <div class="modal-footer d-block">
    <div class="row g-3 justify-content-start form-actions">
      <div class="col-md-3">
        <button id="dialog" type="button" class="btn form-actions-btn d-grid btn-secondary" (click)="handleConfirm()"
          [disabled]="this.isConfrimDisabled">{{'CONFIRM' | globalTranslate}}</button>
      </div>
    </div>
  </div>
</div>